import { FormattedMessage } from 'react-intl'
import {
  always,
  anyPass,
  compose,
  defaultTo,
  ifElse,
  isEmpty,
  isNil,
  join,
  map,
  pluck,
  prop,
} from 'ramda'

export const renderRoleNames = (value) =>
  compose(
    ifElse(
      anyPass([isNil, isEmpty]),
      always(<FormattedMessage id="teamMembers.table.noRolesAssigned.label" />),
      compose(
        join(',\n'),
        map(
          compose(
            defaultTo(
              <FormattedMessage id="teamMembers.table.noRoleNameAvailable.label" />,
            ),
            prop('name'),
          ),
        ),
      ),
    ),
    prop('roles'),
  )(value)

export const renderLabelRoleName = (roles, selected) => {
  const filterRoles = roles.filter((role) => selected.includes(role.id))

  return compose(join(', '), pluck('name'))(filterRoles)
}

export const sortRoleByName = (a, b) =>
  prop('name', a).localeCompare(prop('name', b))
